import React from "react";
import { Wrapper } from "../styles";
import { CustomDivider } from "../styles/Main.styled";
import { Button } from "../styles/Design";
import styled from 'styled-components';
import { Link } from "react-router-dom";


const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  `;

const FormInput = styled.input`
  border: 1px solid #E8E8E8;
  border-radius: 5px;
  background-color: #FBFBFB;
  padding: 8px;
  width: 100%;
  height: 50px;
  font-size: 16px;
  ${(props) => props?.width && `width:${props.width};`}
  `;

const FormItem = styled.label`
  display: flex;
  flex-direction: column;
  flex:1;
  height: 100%;
  color: rgba(45, 55, 72,0.56);
  
  ${({ label, required }) => label && `&:before {
    content: "${label} ${required ? "*" : ""}";
  }
`}`;

const GetInTouch = () => {
  return (
    <Wrapper type="container" isSection hasColumns>
      <Wrapper width="30%">
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "500",
            color: "rgba(0,0,0,0.8)",
            marginBottom: "20px",
          }}
        >
          Get In Touch
          <CustomDivider before />
        </h3>
        <p style={{
          fontSize: "16px",
          color: "rgba(40,35,35,0.7)",
        }}>
          Are you looking for any inquiry, advice, suggestion or facing a problem, contact us.
        </p>
      </Wrapper>
      <Wrapper width="40%">
        <Form>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "2rem",
          }}>
            <FormItem required label="First Name" htmlFor="first_name">
              <FormInput required width="95%" type="text" placeholder="First Name" name="first_name" />
            </FormItem>
            <FormItem required label="Last Name" htmlFor="last_name">
              <FormInput required width="95%" type="text" placeholder="Last Name" name="last_name" />
            </FormItem>
          </div>
          <FormItem required label="Email" htmlFor="email">
            <FormInput required type="email" placeholder="Email" name="email" />
          </FormItem>

          <p style={{
            color: "rgba(40,35,35,0.7)",
            margin: '2rem 0'
          }}>
            *By submitting this form, you agree to BLEND's <Link to="#">Privacy Policy</Link> and <Link to="#">Terms and Conditions</Link>.
          </p>
          <Button style={{
            width: "fit-content",
          }} type="secondary" htmlType="submit">Send</Button>
        </Form>
      </Wrapper>
    </Wrapper>
  );
};

export default GetInTouch;
